import { Image, Button } from "antd";
import MonogramIcon from "assets/images/mongram.jpg";
import { FilterIcon, SearchIcon } from 'svgIcon';
import { baseImageURL } from 'utils/env';
import { useGlobalMerchant } from 'utils/helper';
import TextBoxComponent from 'components/FormComponent/TextBoxComponent';

const POSProductComponent = ({
    isHaveSubCategory,
    catClick,
    handleSubCategoryClick,
    filterProductList,
    addedToCart,
    handleCartAction,
    labelList
}: any) => {
    const { globalMerchantCurrency } = useGlobalMerchant();
    return (
        <div className="proListWrapper">
            {isHaveSubCategory ? (
                <>
                    <div className="proHeader">
                        <p className="mainHeading">{labelList.join(" > ")}</p>
                        <TextBoxComponent name="" id="" />
                        <div className="searchIcon"> <SearchIcon /> </div>
                        <div className="filterIcon"><FilterIcon /></div>
                    </div>
                    <div className="flexWrapper">
                        {catClick && catClick.sub_categories && catClick.sub_categories.length > 0 && catClick.sub_categories.map((item: any) => {
                            return (
                                <div key={item.category_id} className="subCatListWrapper" onClick={() => handleSubCategoryClick(item)}>
                                    <div className="proListImage">
                                        <Image src={item.image_path !== null ? `${baseImageURL}${item.image_path}` : MonogramIcon} alt="product image" />
                                    </div>
                                    <div className="productListContent">
                                        <p className="subInnerHeadingPara"> {item.category_name}</p>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </>
            ) : (
                <>
                    <div className="proHeader">
                        <p className="mainHeading">{catClick.category_name}</p>
                        <TextBoxComponent name="" id="" placeholder="Coming soon..." />
                        <div className="searchIcon"><SearchIcon /></div>
                        <div className="filterIcon"><FilterIcon /> </div>
                    </div>
                    <div className="proBody">
                        {filterProductList && filterProductList.map((product: any) => (
                            <div className="proBodyCover" key={product.product_id}>
                                <div className="proItemWrapper">
                                    <div className="proListImage">
                                        <Image src={product.img !== null ? `${baseImageURL}${product.img}` : MonogramIcon} alt="product image" />
                                    </div>
                                    <div className="proListContent">
                                        <p className="subInnerHeadingPara">{product.product_name}</p>
                                    </div>
                                    <div className="proListBottom">
                                        <p className="subInnerHeading">{product.price} {globalMerchantCurrency}</p>
                                        <div className="disableBtnWrapper">
                                            {product.qty <= 0 ? (
                                                <Button className="disableBtn">Out Of Stock</Button>
                                            ) : (
                                                <Button
                                                    className={addedToCart[product.product_id] ? "commonButtonSmall remove" : "commonButtonSmall add"}
                                                    onClick={() => handleCartAction(product.product_id, product)}
                                                >
                                                    {addedToCart[product.product_id] ? "Remove From Cart" : "Add To Cart"}
                                                </Button>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </>
            )}
        </div>
    )
}

export default POSProductComponent